// extracted by mini-css-extract-plugin
module.exports = {"copyRight":"CopyRight_copyRight__eaq_S"};